import React from "react";
import { Box, Paper, Typography, useTheme } from "@mui/material";
import AssistantActionCard from "./AssistantActionCard";

function ChatMessage({
  message,
  onConfirmAddRecord,
  onCreateReminder,
  onCreateIssue,
  onCancelAction,
}) {
  const theme = useTheme();
  const isUser = message.sender === "user";
  const label = isUser ? "You" : "AutoLogg Assistant";

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: isUser ? "flex-end" : "flex-start",
        mb: 1,
      }}
    >
      <Paper
        sx={{
          maxWidth: "85%",
          p: 1.5,
          backgroundColor: isUser
            ? theme.palette.primary.main
            : theme.palette.background.paper,
          color: isUser ? theme.palette.common.white : theme.palette.text.primary,
          boxShadow: isUser ? theme.shadows[1] : theme.shadows[0],
        }}
        elevation={isUser ? 2 : 0}
      >
        <Typography variant="caption" sx={{ display: "block", mb: 0.5, color: "text.secondary" }}>
          {label}
        </Typography>

        <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
          {message.text}
        </Typography>

        {message.isLoading && (
          <Typography variant="caption" sx={{ mt: 1, display: "block", color: "text.secondary" }}>
            AutoLogg is thinking...
          </Typography>
        )}

        {message.actionData && !message.actionData.completed && (
          <AssistantActionCard
            actionData={message.actionData}
            messageId={message.id}
            onConfirmAddRecord={onConfirmAddRecord}
            onCreateReminder={onCreateReminder}
            onCreateIssue={onCreateIssue}
            onCancelAction={onCancelAction}
          />
        )}

        {message.actionData?.completed && (
          <Typography variant="caption" sx={{ mt: 1, display: "block", color: "text.secondary" }}>
            Action completed.
          </Typography>
        )}
      </Paper>
    </Box>
  );
}

export default ChatMessage;
